module.exports = __webpack_public_path__ + "Roboto-Regular.2751ee43015f9884c364.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/angular-bootstrap-md/font/roboto/Roboto-Regular.woff2
// module id = 468
// module chunks = 2